exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "a[data-v-74be9a26] {\n  text-decoration: none;\n}\n", ""]);

